import { render } from "./EmptyListMessage.vue?vue&type=template&id=7974855a"
import script from "./EmptyListMessage.vue?vue&type=script&lang=js"
export * from "./EmptyListMessage.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__